export const ANNOTATION_RECORD_STATUSES = {
  NEW: "new",
  MODIFIED: "modified",
  DELETED: "deleted",
  UNCHANGED: "unchanged",
} as const;

export const ANNOTATION_TYPES = {
  JOURNEY: "journey",
  TRANSACTION: "transaction",
  TRACK_PERSISTENCE: "track-persistence",
  PROXIMITY: "proximity",
  PROXIMITY_TIME_RANGES: "proximity-time-ranges",
} as const;

export const PREDICTION_TYPES = {
  PIN: "pin",
  ZONE: "zone",
} as const;

export const EDITOR_MODES = {
  EDIT: "edit",
  READ_ONLY: "readOnly",
} as const;

export const MIN_PRODUCT_COUNT = 1;
export const MAX_PRODUCT_QUANTITY_IN_ANY_UNIT = 1_000_00;

export const CUSTOMER_ACTIONS = {
  TAKE: "take",
  PUT: "put",
} as const;

export const ANNOTATION_ACTIONS = {
  ADD: "add",
  REMOVE: "remove",
} as const;

export const CART_VIEWS = {
  ORDER: "order",
  ANNOTATED: "annotated",
  PREDICTION: "prediction",
} as const;

export const TIMELINE_EVENT_TYPES = {
  EVENT: "journey-event",
  TRANSACTION: "transaction",
  TRACK_PERSISTENCE: "track-persistence",
  PROXIMITY: "proximity",
  PROXIMITY_TIME_RANGES: "proximity-time-ranges",
  ORDER: "order",
  PIN_BASED_PREDICTION: "pin-based-prediction",
  ZONE_BASED_PREDICTION: "zone-based-prediction",
} as const;

export const CAMERA_MODES = {
  ALL: "all",
  HAND: "hand",
  SHELF: "shelf",
} as const;

export const HAND_IDS = {
  RIGHT: "0",
  LEFT: "1",
} as const;

export const HAND_SIDES = {
  LEFT: "Left",
  RIGHT: "Right",
} as const;
